import React from "react";
import { Tooltip, Tag, Space, Typography, Divider } from "antd";
import { EnvironmentOutlined, InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const GpsFeeTooltip = ({ gpsFeesData, children }) => {
  if (!gpsFeesData || !gpsFeesData.total_fee || gpsFeesData.total_fee === 0) {
    return children;
  }

  const tooltipContent = (
    <div style={{ maxWidth: 350 }}>
      <div style={{ marginBottom: 8 }}>
        <Text strong style={{ color: '#fff' }}>GPS Tracker Fees Breakdown</Text>
      </div>
      
      <div style={{ marginBottom: 12 }}>
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text style={{ color: '#fff' }}>Total GPS Trackers:</Text>
            <Tag color="blue">{gpsFeesData.tracker_count || 0}</Tag>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text style={{ color: '#fff' }}>Total Months Charged:</Text>
            <Tag color="orange">{gpsFeesData.total_months_charged || 0}</Tag>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text style={{ color: '#fff' }}>Total GPS Fees:</Text>
            <Tag color="red">K{(gpsFeesData.total_fee || 0).toLocaleString()}</Tag>
          </div>
        </Space>
      </div>

      {gpsFeesData.breakdown && gpsFeesData.breakdown.length > 0 && (
        <>
          <Divider style={{ margin: '8px 0', borderColor: 'rgba(255,255,255,0.3)' }} />
          <div style={{ marginBottom: 8 }}>
            <Text style={{ color: '#fff', fontSize: '12px' }} strong>Per Tracker Details:</Text>
          </div>
          <div style={{ maxHeight: 150, overflowY: 'auto' }}>
            {gpsFeesData.breakdown.map((tracker, index) => (
              <div 
                key={tracker.trackerId || index}
                style={{ 
                  marginBottom: 6, 
                  padding: '4px 8px', 
                  backgroundColor: 'rgba(255,255,255,0.1)', 
                  borderRadius: 4,
                  fontSize: '11px'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Text style={{ color: '#fff', fontSize: '11px' }}>{tracker.gpsCode || 'N/A'}</Text>
                  <Space size="small">
                    <Tag size="small" color="cyan">{tracker.monthsCharged || 0}m</Tag>
                    <Tag size="small" color="gold">K{(tracker.totalFee || 0).toLocaleString()}</Tag>
                  </Space>
                </div>
                {tracker.dateIssued && (
                  <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: '10px' }}>
                    Issued: {new Date(tracker.dateIssued).toLocaleDateString()}
                  </Text>
                )}
              </div>
            ))}
          </div>
        </>
      )}
      
      <Divider style={{ margin: '8px 0', borderColor: 'rgba(255,255,255,0.3)' }} />
      <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '10px' }}>
        * GPS fees are calculated monthly from issue date
      </Text>
    </div>
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement="topRight"
      color="#1f1f1f"
      overlayStyle={{ maxWidth: 400 }}
    >
      <span style={{ cursor: 'help', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {children}
        <InfoCircleOutlined 
          style={{ 
            color: '#1890ff', 
            fontSize: '12px',
            opacity: 0.8
          }} 
        />
      </span>
    </Tooltip>
  );
};

export const GpsFeeIndicator = ({ gpsFeesData, showIcon = true }) => {
  if (!gpsFeesData || !gpsFeesData.total_fee || gpsFeesData.total_fee === 0) {
    return null;
  }

  return (
    <GpsFeeTooltip gpsFeesData={gpsFeesData}>
      <Tag 
        color="volcano"
        style={{ 
          cursor: 'help',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4
        }}
      >
        {showIcon && <EnvironmentOutlined />}
        GPS: K{(gpsFeesData.total_fee || 0).toLocaleString()}
      </Tag>
    </GpsFeeTooltip>
  );
};

export default GpsFeeTooltip;